module.exports = __webpack_public_path__ + "static/img/jiantou.d62b356.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiantou.png
// module id = U8AV
// module chunks = 1